import {
  FORM_TOKENS_DB_NAME,
  FORM_TOKENS_DB_VERSION,
  FORM_TOKENS_STORE_NAME,
} from '../../constants';
import { isFormTokensDbAvailable } from './isFormTokensDbAvailable';

let dbPromise: Promise<IDBDatabase | null> | null = null;

// Memoized connection; resolves null instead of rejecting so callers can degrade
// gracefully. A failed open is NOT cached — the next call retries, so a
// transient error cannot poison the whole session.
export const openFormTokensDb = (): Promise<IDBDatabase | null> => {
  if (dbPromise) {
    return dbPromise;
  }

  if (!isFormTokensDbAvailable()) {
    return Promise.resolve(null);
  }

  dbPromise = new Promise<IDBDatabase | null>((resolve) => {
    const failAndRetryLater = () => {
      dbPromise = null;
      resolve(null);
    };

    try {
      const request = window.indexedDB.open(
        FORM_TOKENS_DB_NAME,
        FORM_TOKENS_DB_VERSION
      );

      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(FORM_TOKENS_STORE_NAME)) {
          request.result.createObjectStore(FORM_TOKENS_STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = failAndRetryLater;
      request.onblocked = failAndRetryLater;
    } catch {
      failAndRetryLater();
    }
  });

  return dbPromise;
};
